export default __webpack_public_path__ + "static/media/icon-play.251655f1.webp";